import { createStore } from 'vuex'
import GlobalChatWebSocketService from '@/user/services/globalChatService';
import { initWebSocketNotifications, startPollingUnreadCounts } from '@/user/services/notificationService';

// 定义用户信息接口
interface UserInfo {
  [key: string]: any; // 允许任意属性
}

// 定义状态接口
interface State {
  userInfo: UserInfo | null;
  token: string;
}

export default createStore({
  state: {
    userInfo: null,
    token: localStorage.getItem('token') || ''
  } as State,
  getters: {
    isAuthenticated: (state: State): boolean => !!state.token,
    getUserInfo: (state: State): UserInfo | null => state.userInfo
  },
  mutations: {
    SET_USER_INFO(state: State, userInfo: UserInfo | null) {
      state.userInfo = userInfo;
      // 同时保存到localStorage
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      } else {
        localStorage.removeItem('userInfo');
      }
    },
    SET_TOKEN(state: State, token: string) {
      state.token = token;
      // 同时更新localStorage
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    CLEAR_AUTH_DATA(state: State) {
      state.userInfo = null;
      state.token = '';
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
    }
  },
  actions: {
    // 登录后设置用户信息
    setUserInfo({ commit }, userInfo: UserInfo | null) {
      commit('SET_USER_INFO', userInfo);
    },
    
    // 登出操作
    async logout({ commit }) {
      try {
        const { logout: apiLogout } = await import('../api/auth');
        const response: any = await apiLogout();
        
        // 检查响应格式 - 根据用户反馈，code: 1 表示成功
        if (response && response.code === 1) {
          // 清除本地数据
          commit('CLEAR_AUTH_DATA');
          
          // 断开WebSocket连接
          GlobalChatWebSocketService.disconnect();
          
          return true;
        } else {
          console.error('登出失败:', response);
          // 即使服务器登出失败，也要清除本地数据并断开连接
          commit('CLEAR_AUTH_DATA');
          GlobalChatWebSocketService.disconnect();
          return false;
        }
      } catch (error) {
        console.error('登出请求失败:', error);
        // 即使请求失败，也要清除本地数据并断开连接
        commit('CLEAR_AUTH_DATA');
        GlobalChatWebSocketService.disconnect();
        return true;
      }
    },
    
    // 初始化时尝试恢复用户信息
    async initializeAuth({ commit, state }) {
      if (state.token) {
        // 我们只是检查token是否存在，如果存在则认为用户已登录
        // 但我们需要用户信息，所以我们需要从localStorage中恢复
        
        // 检查当前页面是否属于用户端（非管理端）
        const isUserPage = !window.location.pathname.includes('/admin');
        if (!isUserPage) {
          console.log('当前在管理端页面，跳过WebSocket连接和通知初始化');
          return;
        }
        
        // 从localStorage恢复用户信息
        const storedUserInfo = localStorage.getItem('userInfo');
        if (storedUserInfo) {
          try {
            const userInfo = JSON.parse(storedUserInfo);
            commit('SET_USER_INFO', userInfo);
            
            // 如果有token和用户信息，连接WebSocket
            GlobalChatWebSocketService.connect(state.token);
            // 初始化WebSocket通知处理
            initWebSocketNotifications();
            // 启动未读消息数轮询
            startPollingUnreadCounts(30000);
          } catch (e) {
            console.error('解析用户信息失败:', e);
          }
        }
      }
    }
  },
  modules: {
  }
})